export default __webpack_public_path__ + "static/char-v-39-77413eee51a027e760bd15fcd09ff095.webp";